import { GoDeeperWidget } from "../ui/widgets/goDeeperWidget.ts";
import {
  fetchRecommendationPostsWithAutoTags,
  fetchDetailedPosts,
} from "../utils/searchService.ts";
import { createLogger } from "../utils/logger.ts";
import { WidgetWrapper } from "../utils/WidgetWrapper.ts";
import { WidgetRenderProps } from "../types.ts";

export async function renderV9({
  pageConfig,
  experiment,
}: WidgetRenderProps): Promise<HTMLElement | null> {
  const posts = await fetchRecommendationPostsWithAutoTags(pageConfig, 10, "v1");
  if (posts.length === 0) {
    return null;
  }

  // Fetch detailed post data for go-deeper widget
  const postIds = posts.map((post) => post.id);
  const firstPostUrl = posts[0]?.url;

  if (!firstPostUrl) {
    return null;
  }

  const hostname = new URL(firstPostUrl).hostname;
  const detailedPosts = await fetchDetailedPosts(
    postIds,
    hostname,
    pageConfig.property
  );

  if (detailedPosts.length === 0) {
    return null;
  }

  // Shuffle the posts
  const shuffledPosts = detailedPosts.sort(() => Math.random() - 0.5);

  const logger = createLogger(experiment);

  // Create the widget with detailed posts
  const widget = GoDeeperWidget({
    title: "", // No title needed for Go Deeper widget
    posts: shuffledPosts,
    siteRenderer: pageConfig.siteRenderer,
    logger,
    adLocation: "bottom-of-article",
  });

  return WidgetWrapper(logger, detailedPosts, widget, 0.05);
}
